export const sanitizeHeartRateMonitorId = (heartRateMonitor) => {
  if (!heartRateMonitor) {
    return '';
  }

  return heartRateMonitor.length > 0 && (+heartRateMonitor).toString()
    ? (+heartRateMonitor).toString()
    : '';
}
